import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Content-only skeleton for the stats page.
 * Use this when the header and controls are already rendered and only the charts area is loading.
 */
export function StatsContentSkeleton() {
  return (
    <div className="space-y-6" aria-busy="true" aria-label="Loading statistics">
      {/* Charts Section */}
      <div className="space-y-4">
        <Skeleton className="h-6 w-16" />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Chart 1 - Bar Chart */}
          <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-200 dark:border-slate-700/50 p-6 shadow-sm">
            <div className="flex items-center justify-between mb-6">
              <Skeleton className="h-5 w-36" />
            </div>
            <div className="h-48 flex items-end gap-2 pt-4">
              {Array.from({ length: 7 }).map((_, i) => (
                <div key={i} className="flex-1 flex flex-col items-center gap-2">
                  <Skeleton
                    className="w-full rounded-t"
                    style={{ height: `${40 + (i % 3) * 20}%` }}
                  />
                  <Skeleton className="h-3 w-6" />
                </div>
              ))}
            </div>
          </div>

          {/* Chart 2 - 2x2 grid of Radial Charts */}
          <div className="grid grid-cols-2 gap-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="bg-white dark:bg-slate-800 rounded-xl border border-gray-200 dark:border-slate-700/50 p-4 shadow-sm"
              >
                <div className="flex items-center gap-2 mb-3">
                  <Skeleton className="h-8 w-8 rounded-lg" />
                  <Skeleton className="h-4 w-20" />
                </div>
                <div className="flex items-center justify-center">
                  <Skeleton className="h-24 w-24 rounded-full" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bookings Over Time - Line Chart */}
        <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-200 dark:border-slate-700/50 p-6 shadow-sm">
          <Skeleton className="h-5 w-40 mb-6" />
          <Skeleton className="h-64 w-full rounded-lg" />
        </div>

        {/* Users Section */}
        <Skeleton className="h-6 w-14 mt-4" />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Leaderboard */}
          <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-200 dark:border-slate-700/50 p-6 shadow-sm">
            <Skeleton className="h-5 w-32 mb-4" />
            <div className="space-y-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="flex items-center gap-3">
                  <Skeleton className="h-8 w-8 rounded-full" />
                  <Skeleton className="h-4 w-28 flex-1" />
                  <Skeleton className="h-5 w-10" />
                </div>
              ))}
            </div>
          </div>

          {/* Another Chart */}
          <div className="bg-white dark:bg-slate-800 rounded-xl border border-gray-200 dark:border-slate-700/50 p-6 shadow-sm">
            <Skeleton className="h-5 w-36 mb-4" />
            <div className="space-y-3">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="flex items-center gap-3">
                  <Skeleton className="h-8 w-8 rounded-lg" />
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-2 w-24 rounded-full flex-1" />
                  <Skeleton className="h-4 w-8" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
